export const integrationResourcesToRecord = <T extends { uid: string }>(
  resources: T[] = [],
): Record<string, T> =>
  resources.reduce<Record<string, T>>((result, resource) => {
    result[resource.uid] = resource;
    return result;
  }, {});
